import * as React from 'react';
import { IconProps } from '../types';

const IcAnyBody = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
   <g clipPath="url(#a)">
      <path
        fill={props?.fill ?? '#232F3E'}
        d="M24.5 15.9c0-2.8-1.5-5-3.7-6.1 1-1 1.7-2.3 1.7-3.8 0-2.8-2.2-5-5-5-2.1 0-3.8 1.2-4.6 3h-.8c-.8-1.8-2.5-3-4.6-3-2.8 0-5 2.2-5 5 0 1.5.7 2.8 1.7 3.8C2 10.9.5 13.2.5 15.9V20h5v3h14v-3h5v-4.1ZM17.5 3c1.7 0 3 1.3 3 3 0 1.6-1.3 3-3 3 0-1.9-1.1-3.5-2.7-4.4.5-1 1.5-1.6 2.7-1.6Zm-2 6c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.3 3 3Zm-8-6c1.2 0 2.2.6 2.7 1.6-1.6.9-2.7 2.5-2.7 4.4-1.7 0-3-1.3-3-3s1.3-3 3-3ZM5.6 18H2.5v-2.1c0-2.8 2.1-4.9 5-4.9h.3c.3.7.8 1.3 1.3 1.8-1.9 1-3.2 2.9-3.5 5.2Zm11.9 3h-10v-2.1c0-2.8 2.2-4.9 5-4.9 2.9 0 5 2.1 5 4.9V21Zm5-3h-3.1c-.3-2.3-1.7-4.2-3.7-5.2.6-.5 1-1.1 1.3-1.8h.4c2.9 0 5 2.1 5 4.9V18h.1Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h24v24H.5z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcAnyBody;